// src/encounter/encounter-documents-panel.tsx
// The encounter's Documents tab BODY (the prototype's header has Encounter · Chart · Documents). Nothing new
// is built: it is the encounter-scoped list the Docs step already draws (`DocumentsChartTab`, `listScope="encounter"`,
// `surface="encounter-step"`: this visit's documents only, its own header over a bare list, add and row actions as in the
// step), in the same one scroller the Chart tab uses. The tab is offered only once the visit's encounter exists: the list
// is scoped to it, so without it there is nothing honest to show.
import { DocumentsChartTab } from '@/patients/components/chart/documents-chart-tab';

export interface EncounterDocumentsPanelProps {
  patientId: string;
  encounterId: string;
}

export function EncounterDocumentsPanel({ patientId, encounterId }: EncounterDocumentsPanelProps) {
  return (
    <div className="flex-1 min-w-0 min-h-0 flex flex-col">
      <div className="flex-1 min-w-0 min-h-0 overflow-y-auto scrollbar-hide p-6" data-slot="encounter-documents-scroller">
        <DocumentsChartTab patientId={patientId} encounterId={encounterId} listScope="encounter" surface="encounter-step" />
      </div>
    </div>
  );
}
